var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('service-toolbar',{attrs:{"heading":"Service Apps"}}),_c('addon-app-tab',{attrs:{"ui-location":"Service Record"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }